import { render, staticRenderFns } from "./IconArea.vue?vue&type=template&id=14ed7f36"
import script from "./IconArea.vue?vue&type=script&lang=js"
export * from "./IconArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports